export const LOAD_PROFILE = 'PROFILE/LOAD';
export const LOADING_STATUS = 'PROFILE/LOADING_STAUS';
